import React from "react";
import { RicosContentQueryService } from "./ContentQueryService.js";
const contentQueryService = new RicosContentQueryService();
const ContentQueryContext = React.createContext(contentQueryService);
export {
  ContentQueryContext
};
//# sourceMappingURL=ContentQueryContext.js.map
